import { FormattedMessage } from 'react-intl';
import React from 'react';
import LinkedInLink from './LinkedInLink';
import Paragraph from './UI/Paragraph';
import Title from './UI/Title';
import style from '../pages/Contact.module.css';

function Proposition() {
  return (
    <section className="col-12 col-lg-4 col-xl-4">
      <div className="row">
        <div className="col-12">
          <Title level={2} custom css="text-uppercase mb-0 ft-wt-600">
            <FormattedMessage id="contact.proposal-title" />
          </Title>
        </div>
        <div className="col-12">
          <Paragraph justify translationId="contact.proposal-content" />
          <Paragraph translationId="contact.else-linkedin" />
          <span className={style.linkedInLink}>
            <LinkedInLink>
              <span className="d-block mt-3">
                <FormattedMessage id="contact.linkedin-profile-title" />
              </span>
            </LinkedInLink>
          </span>
        </div>
      </div>
    </section>
  );
}

export default Proposition;
